import React, { Fragment } from 'react';
import { chunk, includes, sampleSize, slice } from 'lodash';
import cx from 'classnames';
import DragScroll from 'react-indiana-drag-scroll';
import WidgetPreviewTitle from '../../WidgetPreviewTitle';
import Slider from '../../../../../../components/utils/Slider/Slider';
import WidgetPreviewProductItem from '../WidgetPreviewProductItem';
import Img from '../../../../../../components/Img/Img';
import { setFilterValidWidgetItem } from '../../../../../../lib/utils/widgetUtils';
import {
  UNNECESSARY_BRAND_NAME_AND_LIKE_BUTTON_PRODUCT_LAYOUT_TYPE_LIST,
  WIDGET_PRODUCT_SECTION_LAYOUT_INFO,
  WIDGET_SECTION_COMPONENT_TYPE,
} from '../../../../../../constants/service/app/widgetConstants';
import './WidgetPreviewProductWrap.scss';

const WidgetPreviewProductWrap = (props) => {
  const { widgetInfo, selectedWidgetItemList, widgetSection, moveToDetailPage } = props;
  const { widgetType, layoutType, mainTitle, isUsedSubTitle, subTitle, isUsedButton, widgetButtonText } = widgetInfo;
  const { topImg, isRandomItem, exposureItemCount, exposureWidgetItemList } = widgetSection;

  /**
   *  위젯 아이템 리스트
   *  위젯 아이템 랜덤 노출일 경우에는 위젯 리스트를 랜덤으로 정렬함
   */
  const widgetItemList = isRandomItem
    ? sampleSize(setFilterValidWidgetItem(selectedWidgetItemList), exposureItemCount)
    : setFilterValidWidgetItem(exposureWidgetItemList);

  /**
   *  위젯 레이아웃 타입별 섹션 레이아웃 정보
   *  정의되지 않은 레이아웃 타입은 기획 변경으로 인해 deprecated된 레이아웃 타입임
   */
  let lastIndex = 0;
  const widgetSectionLayoutList = WIDGET_PRODUCT_SECTION_LAYOUT_INFO[layoutType]
    ? WIDGET_PRODUCT_SECTION_LAYOUT_INFO[layoutType].map((layoutInfo) => {
        /**
         *  위젯 섹션별로 위젯 아이템 개수를 분할함
         */
        let sectionItemList = slice(widgetItemList, lastIndex, lastIndex + layoutInfo.NUMBER_OF_WIDGET_ITEM_COUNT);
        lastIndex = lastIndex + layoutInfo.NUMBER_OF_WIDGET_ITEM_COUNT;

        return {
          /**
           *  위젯 섹션 컴포넌트 타입
           */
          componentType: layoutInfo.COMPONENT_TYPE,
          /**
           *  위젯 아이템 행렬 레이아웃의 행의 개수
           */
          numberOfRowCount: layoutInfo.NUMBER_OF_ROW_COUNT,
          /**
           *  위젯 아이템 행렬 레이아웃의 열의 개수
           */
          numberOfColumnCount: layoutInfo.NUMBER_OF_COLUMN_COUNT,
          /**
           *  이미지 마진 사용하지 않은 여부
           */
          isNotImgMargin: layoutInfo.IS_NOT_IMG_MARGIN,
          /**
           *  스와이프 사이즈
           */
          swipeSize: layoutInfo.SWIPE_SIZE,
          /**
           *  섹션 아이템 리스트
           */
          sectionItemList,
        };
      })
    : [];

  const widgetComponentType = {
    /**
     *  그리드
     */
    [WIDGET_SECTION_COMPONENT_TYPE.GRID]: (layoutInfo) => {
      return (
        <Slider
          className="widget-product-section-grid"
          emptyText={
            widgetInfo.isProductRecommend ? (
              <>
                자동 추천 위젯은 <br /> 위젯 아이템 미리보기가 불가합니다.
              </>
            ) : (
              '홈에 노출 될 위젯 아이템 리스트 설정해주세요.'
            )
          }
          list={chunk(layoutInfo.sectionItemList, layoutInfo.numberOfRowCount * layoutInfo.numberOfColumnCount)}
          arrows={false}
          adaptiveHeight={false}
          item={(section) => (
            <div className={cx('widget-product-section', `col-${layoutInfo.numberOfColumnCount}`)}>
              {section.map((productItem, index) => (
                <WidgetPreviewProductItem
                  key={index}
                  productItem={productItem}
                  unnecessaryBrandNameAndLikeButton={includes(
                    UNNECESSARY_BRAND_NAME_AND_LIKE_BUTTON_PRODUCT_LAYOUT_TYPE_LIST,
                    layoutType,
                  )}
                />
              ))}
            </div>
          )}
        />
      );
    },

    /**
     *  스크롤
     */
    [WIDGET_SECTION_COMPONENT_TYPE.SCROLL]: (layoutInfo) => {
      return (
        <div className="widget-product-section-scroll">
          <div className={cx('widget-product-section', { 'is-not-img-margin': layoutInfo.isNotImgMargin })}>
            {widgetSectionLayoutList[0] &&
              widgetSectionLayoutList[0].sectionItemList.map((productItem, index) => (
                <WidgetPreviewProductItem key={index} productItem={productItem} />
              ))}
          </div>
        </div>
      );
    },
    /**
     *  스와이프
     */
    [WIDGET_SECTION_COMPONENT_TYPE.SWIPE]: (layoutInfo) => {
      return (
        <Fragment>
          {
            /**
             *  위젯 탑 이미지
             */
            topImg && topImg.length && topImg[0] && topImg[0].url ? (
              <Img className="widget-top-image" clickAble={false} src={topImg[0].url} />
            ) : null
          }
          <div className="widget-product-section-swipe">
            <DragScroll className={cx('widget-product-section', layoutInfo.swipeSize)}>
              {layoutInfo.sectionItemList?.map((productItem, index) => (
                <WidgetPreviewProductItem
                  key={index}
                  productItem={productItem}
                  unnecessaryBrandNameAndLikeButton={includes(
                    UNNECESSARY_BRAND_NAME_AND_LIKE_BUTTON_PRODUCT_LAYOUT_TYPE_LIST,
                    layoutType,
                  )}
                />
              ))}
            </DragScroll>
          </div>
        </Fragment>
      );
    },
    /**
     *  갤러리
     */
    [WIDGET_SECTION_COMPONENT_TYPE.GALLERY]: (layoutInfo) => {
      return (
        <div className="widget-product-section-gallery">
          <div className="widget-product-section">
            {layoutInfo.sectionItemList.map((productItem, index) => (
              <Img key={index} clickAble={false} src={productItem.url} />
            ))}
          </div>
        </div>
      );
    },
  };

  const sectionList = widgetSectionLayoutList.map((layoutInfo, sectionIndex) => (
    <div key={sectionIndex}>{widgetComponentType[layoutInfo.componentType](layoutInfo)}</div>
  ));

  return (
    <div className="widget-preview-product-wrap">
      {
        /**
         *  위젯 타이틀, 위젯 서브 타이틀
         */
        <WidgetPreviewTitle
          widgetType={widgetType}
          mainTitle={mainTitle}
          isUsedSubTitle={isUsedSubTitle}
          subTitle={subTitle}
        />
      }

      {widgetSectionLayoutList.length > 0 && !widgetInfo.isProductRecommend ? (
        <div className="widget-product-item-list">{sectionList}</div>
      ) : (
        <div className="product-recommend-type-item">
          <p>
            자동 추천 위젯은
            <br /> 위젯 아이템 미리보기가 불가합니다.
          </p>
        </div>
      )}
      {
        /**
         *  위젯 버튼
         */
        isUsedButton && !widgetInfo.isProductRecommend ? (
          <div className="widget-product-button" onClick={() => moveToDetailPage && moveToDetailPage()}>
            {widgetButtonText ? widgetButtonText : <span className="require-info">위젯 버튼명을 설정해주세요.</span>}
          </div>
        ) : null
      }
    </div>
  );
};

export default WidgetPreviewProductWrap;
